module.exports = __webpack_public_path__ + "img/radiaIcon3.fa6f3b75.png";